import React from 'react';
import {Alert} from 'antd';
import {Circle, GoogleMap, LoadScript, Marker} from '@react-google-maps/api';

export type GeoPoint = {
    lat: number;
    lng: number;
};

type GeoRadiusMapProps = {
    center: GeoPoint;
    radiusKm: number;
    height?: number;
    readOnly?: boolean;
    zoom?: number;
    onCenterChange?: (center: GeoPoint) => void;
};

const googleMapsApiKey = process.env.REACT_APP_MAPS_API_KEY || process.env.REACT_APP_GOOGLE_MAPS_KEY || '';

const GeoRadiusMap: React.FC<GeoRadiusMapProps> = ({
    center,
    radiusKm,
    height = 320,
    readOnly = false,
    zoom = 10,
    onCenterChange,
}) => {
    const handleLocationChange = (event: google.maps.MapMouseEvent) => {
        if (readOnly || !event.latLng) return;

        onCenterChange?.({
            lat: event.latLng.lat(),
            lng: event.latLng.lng(),
        });
    };

    if (!googleMapsApiKey) {
        return (
            <Alert
                type="warning"
                message="Google Maps API key is not configured."
                description="Set REACT_APP_MAPS_API_KEY to enable geographic radius targeting."
            />
        );
    }

    return (
        <LoadScript googleMapsApiKey={googleMapsApiKey}>
            <GoogleMap
                mapContainerStyle={{width: '100%', height}}
                center={center}
                zoom={zoom}
                onClick={handleLocationChange}
                options={{
                    clickableIcons: !readOnly,
                    fullscreenControl: false,
                    mapTypeControl: false,
                    streetViewControl: false,
                }}
            >
                <Marker
                    position={center}
                    draggable={!readOnly}
                    onDragEnd={handleLocationChange}
                />
                <Circle
                    center={center}
                    radius={radiusKm * 1000}
                    options={{
                        fillColor: '#1677ff',
                        fillOpacity: 0.18,
                        strokeColor: '#1677ff',
                        strokeOpacity: 0.8,
                        strokeWeight: 2,
                    }}
                />
            </GoogleMap>
        </LoadScript>
    );
};

export default GeoRadiusMap;
